import { CountryIsoNumber } from '../../models/country/country-iso-number.enum';

// https://github.com/validatorjs/validator.js/blob/master/src/lib/isPostalCode.js
export const CountryPostalCodeFormat: Record<CountryIsoNumber, RegExp> = {
  [CountryIsoNumber.GreatBritain]: new RegExp(
    /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/i,
  ),
  [CountryIsoNumber.Ireland]: new RegExp(
    // /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
    /^[A-Z]\d{2}\s[A-Z0-9]{4}$/i,
  ),
};
